export const GEOAD_CURRENCY = 'SGD';
export const GEOAD_BACKEND = 'https://us-central1-elevatortvbackend.cloudfunctions.net/geoad-api-buildingowner';
export const GEOAD_DEFAULT_RATES = {
  MORNING_PEAK: '30.00',
  LUNCH_PEAK: '22.50',
  DAYTIME_FLOW: '15.00',
  EVENING_PEAK: '30.00',
  OFF_PEAK: '7.50',
};
